var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showAppWarning)?_c('div',[_c('AppWarning',{attrs:{"text":_vm.warningText,"type":_vm.warningType,"showButton":false}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }